import React, { Component } from 'react';
import { connect } from 'react-redux';
import { MODAL_SHARE_VIEW } from '../../util/enums/EnumModals';
import { CopyBox } from '../CopyBox';

class ModalShareView extends Component {
  static modalType() {
    return MODAL_SHARE_VIEW;
  }

  static reducer(modals) {
    return modals.shareViewModal;
  }

  static title() {
    return (
      <span>
        <span
          className="glyphicon glyphicon-share-alt margin-right-10"
          aria-hidden="true"
        />
        Export as live feed
      </span>
    );
  }

  static includeSaveButton() {
    return false;
  }

  urlBox(key, url) {
    return (
      <CopyBox key={key} value={url}>
        <button
          className="btn btn-primary"
          type="button"
          onClick={() => window.open(url, '_blank')}
        >
          Download
        </button>
      </CopyBox>
    );
  }

  render() {
    const { state, view } = this.props;
    const prefix = view.downloadPrefix();
    const suffix = view.downloadSuffix();

    const changeLimitsButton = (
      <small>
        <b>To change limits</b>, ask your admin.
      </small>
    );
    this._notifications = {};

    let index = 1;
    const buildTr = (el) => (
      <tr key={index++}>
        <td>{el}</td>
      </tr>
    );
    const trs = [];
    trs.push(
      buildTr(<label className="form-control-label">CSV (for Excel)</label>),
    );
    trs.push(buildTr(this.urlBox('csv', `${prefix + suffix}.csv`)));
    trs.push(
      buildTr(
        <small className="pull-right subtle">
          Want your live results in Google Sheets? Check out this{' '}
          <a href="https://youtu.be/xTo-3CN2GPk" target="_blank">
            video
          </a>
        </small>,
      ),
    );
    trs.push(buildTr(<label className="form-control-label">JSON</label>));
    trs.push(buildTr(this.urlBox('json', `${prefix + suffix}.json`)));
    trs.push(buildTr(<small className="pull-right subtle">&nbsp;</small>));
    trs.push(
      buildTr(<label className="form-control-label">CSV (pivot)</label>),
    );
    trs.push(buildTr(this.urlBox('2d-csv', `${prefix}2d/${suffix}.csv`)));
    trs.push(
      buildTr(
        <small className="pull-right subtle">
          Wondering what a 2D table is? Check out this{' '}
          <a href="https://youtu.be/g_eKRIBLRzI" target="_blank">
            video
          </a>
        </small>,
      ),
    );
    trs.push(
      buildTr(
        <div className="text-align-right subtle">
          <small>Max export size: {state.rowLimit} rows</small>
          <br />
          <small>Query timeout: {state.queryTimeoutSeconds} seconds</small>
          <br />
          <br />
          {changeLimitsButton}
        </div>,
      ),
    );
    return (
      <table className="full-width">
        <tbody>{trs}</tbody>
      </table>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAdmin: state.datasource.isAdmin,
    view: state.views.lastLoadedView,
  };
};

export default connect(mapStateToProps)(ModalShareView);
